import { createContext } from "react";

export const RolesContext = createContext<any>({});
